import { render, staticRenderFns } from "./ReportTournament.vue?vue&type=template&id=2900dd14&"
import script from "./ReportTournament.vue?vue&type=script&lang=js&"
export * from "./ReportTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports